import type { LocalizedSpecialKeyMapItem } from '../types'

/**
 * 特殊键展示元数据（icon / keyType / labelKey）。
 * 仅用于解析回显与多媒体 Tab 展示，不参与「能否改键」判断。
 * 能否改键：仅 Fn/RT 禁止；出厂恢复语义走各机型 manifest.factoryKeys.win/mac。
 */
export const SPECIAL_KEY_META_ITEMS: LocalizedSpecialKeyMapItem[] = [
  {
    keywords: 'Disable key',
    keyType: 'normal',
  },
  {
    keywords: 'Fn',
    keyType: 'normal',
  },
  {
    keywords: 'RT',
    keyType: 'normal',
    icon: 'Hardware-Fill-rt',
  },
  {
    keywords: '|◄◄',
    labelKey: 'keys.media.prevTrack',
    keyType: 'media',
    icon: 'Multimedia-Wireframe-PrevTrack',
  },
  {
    keywords: '►||',
    labelKey: 'keys.media.playPause',
    keyType: 'media',
    icon: 'Multimedia-Wireframe-PrevTrack-1',
  },
  {
    keywords: '►►|',
    labelKey: 'keys.media.nextTrack',
    keyType: 'media',
    icon: 'Multimedia-Wireframe-NextTrack',
  },
  {
    keywords: 'Stop',
    labelKey: 'keys.media.stop',
    keyType: 'media',
    icon: 'Multimedia-Wireframe-Stop',
  },
  {
    keywords: '📢✕',
    labelKey: 'keys.media.mute',
    keyType: 'media',
    icon: 'Multimedia-Wireframe-Mute',
  },
  {
    keywords: '📢➕',
    labelKey: 'keys.media.volumeUp',
    keyType: 'media',
    icon: 'Multimedia-Wireframe-Vol1',
  },
  {
    keywords: '📢➖',
    labelKey: 'keys.media.volumeDown',
    keyType: 'media',
    icon: 'Multimedia-Wireframe-Vol2',
  },
  {
    keywords: 'Music',
    labelKey: 'keys.media.player',
    keyType: 'media',
    icon: 'Multimedia-Wireframe-Player',
  },
  {
    keywords: '✉',
    labelKey: 'keys.media.mail',
    keyType: 'media',
    icon: 'Multimedia-Wireframe-Mail',
  },
  {
    keywords: '🏠',
    labelKey: 'keys.media.home',
    keyType: 'media',
    icon: 'Status-Wireframe-Home',
  },
  {
    keywords: '📱',
    labelKey: 'keys.media.calculator',
    keyType: 'media',
    icon: 'Multimedia-Wireframe-Calc1',
  },
  {
    keywords: 'PC',
    labelKey: 'keys.media.myComputer',
    keyType: 'media',
    icon: 'Multimedia-Wireframe-MyPC',
  },
  {
    keywords: 'Browser_Search',
    labelKey: 'keys.media.search',
    keyType: 'media',
    icon: 'Multimedia-Wireframe-Search',
  },
  {
    keywords: 'Browser_Back',
    labelKey: 'keys.media.browserBack',
    keyType: 'media',
    icon: 'Multimedia-Wireframe-PrevPage',
  },
  {
    keywords: 'Browser_Forward',
    labelKey: 'keys.media.browserForward',
    keyType: 'media',
    icon: 'Multimedia-Wireframe-NextPage',
  },
  {
    keywords: 'Browser_Refresh',
    labelKey: 'keys.media.browserRefresh',
    keyType: 'media',
    icon: 'Multimedia-Wireframe-Refresh',
  },
  {
    keywords: 'Browser_Favorites',
    labelKey: 'keys.media.browserFavorites',
    keyType: 'media',
    icon: 'Multimedia-Wireframe-Bookmarks',
  },
  {
    keywords: 'Power',
    labelKey: 'keys.media.systemPower',
    keyType: 'media',
    icon: 'Multimedia-Wireframe-ShutDown',
  },
  {
    keywords: 'Sleep',
    labelKey: 'keys.media.systemSleep',
    keyType: 'media',
    icon: 'Multimedia-Wireframe-Sleep',
  },
  {
    keywords: 'Bright +',
    labelKey: 'keys.media.brightnessUp',
    keyType: 'media',
    icon: 'Multimedia-Wireframe-Brightness1',
  },
  {
    keywords: 'Bright -',
    labelKey: 'keys.media.brightnessDown',
    keyType: 'media',
    icon: 'Multimedia-Wireframe-Brightness2',
  },
  {
    keywords: 'LED_Inc',
    labelKey: 'keys.media.keyboardBrightnessUp',
    keyType: 'media',
    icon: 'Multimedia-Wireframe-KBBr1',
  },
  {
    keywords: 'LED_Dec',
    labelKey: 'keys.media.keyboardBrightnessDown',
    keyType: 'media',
    icon: 'Multimedia-Wireframe-KBBr2',
  },
  {
    keywords: '左击',
    labelKey: 'keys.media.mouseLeft',
    keyType: 'media',
    icon: 'VirtualKey-Wireframe-Left',
  },
  {
    keywords: '右击',
    labelKey: 'keys.media.mouseRight',
    keyType: 'media',
    icon: 'VirtualKey-Wireframe-Right',
  },
  {
    keywords: '中键',
    labelKey: 'keys.media.mouseMiddle',
    keyType: 'media',
    icon: 'VirtualKey-Wireframe-Middle',
  },
  {
    keywords: '右侧',
    labelKey: 'keys.media.mouseForward',
    keyType: 'media',
    icon: 'VirtualKey-Wireframe-Forward',
  },
  {
    keywords: '左侧',
    labelKey: 'keys.media.mouseBack',
    keyType: 'media',
    icon: 'VirtualKey-Wireframe-Back',
  },
  {
    keywords: 'TOG_LED',
    labelKey: 'keys.media.togLed',
    keyType: 'media',
  },
  {
    keywords: 'ScrollLock',
    labelKey: 'keys.media.scrollLock',
    keyType: 'media',
  },
  {
    keywords: 'PauseBreak',
    labelKey: 'keys.media.pauseBreak',
    keyType: 'media',
  },
  {
    keywords: 'Home',
    labelKey: 'keys.media.keyHome',
    keyType: 'media',
  },
  {
    keywords: 'End',
    labelKey: 'keys.media.keyEnd',
    keyType: 'media',
  },
  {
    keywords: 'LED_Color',
    labelKey: 'keys.media.ledColor',
    keyType: 'media',
  },
  {
    keywords: 'WIN_Lock',
    labelKey: 'keys.media.winLock',
    keyType: 'media',
  },
  {
    keywords: 'LEDMode_Forward',
    labelKey: 'keys.media.ledModeUp',
    keyType: 'media',
  },
  {
    keywords: 'LEDMode_Retreat',
    labelKey: 'keys.media.ledModeDown',
    keyType: 'media',
  },
  {
    keywords: 'LED_SI',
    labelKey: 'keys.media.ledSpeedUp',
    keyType: 'media',
  },
  {
    keywords: 'LED_SD',
    labelKey: 'keys.media.ledSpeedDown',
    keyType: 'media',
  },
  {
    keywords: 'SideLED_Mode',
    labelKey: 'keys.media.sideLedMode',
    keyType: 'media',
  },
  {
    keywords: 'SideLED_Color',
    labelKey: 'keys.media.sideLedColor',
    keyType: 'media',
  },
]

/** keywords → 展示元数据 */
export const SPECIAL_KEY_META_BY_KEYWORDS = new Map(
  SPECIAL_KEY_META_ITEMS.map((item) => [item.keywords, item]),
)

/**
 * 未配置 mediaKeys 白名单的机型，TabMedia 回退列表（不含灯效扩展项，保持旧行为）。
 */
export const LEGACY_MEDIA_KEY_KEYWORDS = [
  '|◄◄',
  '►||',
  '►►|',
  'Stop',
  '📢✕',
  '📢➕',
  '📢➖',
  'Music',
  '✉',
  '🏠',
  '📱',
  'PC',
  'Browser_Search',
  'Browser_Back',
  'Browser_Forward',
  'Browser_Refresh',
  'Browser_Favorites',
  'Power',
  'Sleep',
  'Bright +',
  'Bright -',
  'LED_Inc',
  'LED_Dec',
  '左击',
  '右击',
  '中键',
  '右侧',
  '左侧',
] as const
